import React from 'react';
interface BonusCoverProps {
  label: string;
  title: string;
  color: string;
  className?: string;
}
const RINGS = Array.from({
  length: 11
});

/** Small spiral-notebook cover matching the volume covers in the mockup. */
export function BonusCover({
  label,
  title,
  color,
  className = ''
}: BonusCoverProps) {
  return <div className={`relative flex aspect-[3/4] flex-col items-center rounded-r-[8px] rounded-l-[3px] py-[9%] pl-[16%] pr-[8%] text-center shadow-[0_18px_30px_-18px_rgba(59,27,87,0.55)] ${className}`} style={{
    backgroundColor: color
  }} aria-hidden="true" data-id="element-1" data-mp="38a68hfxzoope">
      <span className="absolute inset-y-[5%] left-[5%] flex flex-col justify-between" data-id="element-2" data-mp="3w1bn5rs71ay4">
        {RINGS.map((_, index) => <span key={index} className="block h-[5px] w-[9px] rounded-full border border-brand-gold/80 bg-white/40" data-id="element-3" data-mp="3r30evlhjr8i0" data-mpi={index} />)}
      </span>
      <span className="rounded-full bg-white/70 px-2 py-0.5 font-body text-[8px] font-semibold uppercase tracking-[0.14em] text-brand-charcoal/75" data-id="element-4" data-mp="21olv7fldybtd">
        {label}
      </span>
      <span className="mt-[10%] font-display text-[11px] font-bold uppercase leading-[1.05] text-brand-charcoal" data-id="element-5" data-mp="2cdi1vi6go6ne">
        Makeup Instructor
      </span>
      <span className="font-display text-[17px] font-semibold italic leading-none text-brand-gold" data-id="element-6" data-mp="2lbto780aoia1">Ready</span>
      <span className="mt-auto font-display text-[14px] font-semibold leading-[1.1] text-brand-charcoal" data-id="element-7" data-mp="2q3btg89cp50t">{title}</span>
    </div>;
}